<template>
  <div class="rbca-container">
    <strong>项目访问权限：</strong>
    <p>
      <el-switch v-model="isOpen" active-text="开放全部用户访问" inactive-text="只允许项目成员访问" @change="changeProjectOpenStatus">
      </el-switch>
    </p>
    <strong>新增一个成员到项目：</strong>
    <el-form :inline="true" :model="form" class="demo-form-inline">
      <el-form-item>
        <el-select v-model="form.userId" placeholder="请选择成员" filterable size="mini">
          <el-option v-for="item in memberList" :key="item.id" :label="`${item.realName}(${item.userName})`" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select v-model="form.role" placeholder="请选择成员角色" size="mini">
          <el-option v-for="item in memberRoleList" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="throttle(addProjectMember,200)" size="mini">添加成员到项目</el-button>
      </el-form-item>
    </el-form>
    <strong>现有成员：</strong>
    <el-table :data="nowMemberList" border style="width: 100%" size="mini">
      <el-table-column label="成员名" width="200">
        <template slot-scope="scope">
          {{scope.row.realName}} ({{scope.row.userName}})
        </template>
      </el-table-column>
      <el-table-column label="加入时间" width="250">
        <template slot-scope="scope">
          {{ formatTime(scope.row.createTime) }}
        </template>
      </el-table-column>
      <el-table-column label="当前角色" width="250">
        <template slot-scope="scope">
          <el-select v-model="scope.row.role" placeholder="请选择成员角色" size="mini" @change="changeMemberRole(scope.row)">
            <el-option v-for="item in memberRoleList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column prop="address" label="操作">
        <template slot-scope="scope">
          <el-button size="mini" @click="removeProjectMember(scope.row.id)">移除</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { showLoading, hideLoading } from '@/plugins/loading';
import { userApi, fileManageApi } from '@/api/index';
import { throttle } from '@/common/utils/timerUtil.js';
import { mapGetters } from 'vuex';
import dayjs from 'dayjs'
export default {
  name: 'rbca',
  props: {
    pId: {
      type: String,
      default: ''
    },
  },
  computed: {
    ...mapGetters(['currentProject'])
  },
  data () {
    return {
      form: {
        userId: '',
        role: ''
      },
      memberList: [],
      memberRoleList: [
        { id: 0, name: '项目开发' }, { id: 1, name: '项目管理员' }
      ],
      isOpen: true,
      nowMemberList: [],
      loading: false
    }
  },
  watch: {
    currentProject (val) {
      this.isOpen = val.isOpen;
    }
  },
  mounted () {
    this.getAllUserList();
    this.getProjectMembers();
  },
  methods: {
    // 格式化时间
    formatTime (time) {
      return dayjs(time).format('YYYY-MM-DD HH:mm:ss');
    },
    // 修改成员角色
    async changeMemberRole (row) {
      const res = await fileManageApi.changeMemberRole({ id: row.id, role: row.role });
      if (res.code === 200) {
        this.getProjectMembers();
        this.$emit('getProjectList');
        this.$message.success('修改成功！');
      } else {
        this.$message.error(res.message);
      }
    },
    // 删除项目成员
    async removeProjectMember (id) {
      const res = await fileManageApi.removeProjectMember({ id });
      if (res.code === 200) {
        this.getProjectMembers();
        this.$emit('getProjectList');
        this.$message.success('移除成功！');
      } else {
        this.$message.error(res.message);
      }
    },
    // 获取项目成员列表
    async getProjectMembers () {
      const res = await fileManageApi.getProjectMembers({ pId: this.pId });
      if (res.code === 200) {
        this.nowMemberList = res.data;
      } else {
        this.$message.error(res.message);
      }
    },
    // 改变项目开放状态
    async changeProjectOpenStatus () {
      showLoading();
      const params = {
        id: this.pId,
        isOpen: this.isOpen
      }
      const res = await fileManageApi.changeProjectOpenStatus(params)
      if (res.code === 200) {
        this.$message.success(res.message);
      } else {
        this.$message.error(res.message);
      }
      hideLoading();
    },
    // 添加项目成员
    async addProjectMember () {
      if (!this.form.userId || this.form.role === '') {
        return this.$message.error('成员或者角色不能为空！');
      }
      const res = await fileManageApi.addProjectMember({ ...this.form, pId: this.pId });
      if (res.code === 200) {
        this.getProjectMembers();
        this.$emit('getProjectList');
        this.$message.success('添加成功！');
      } else {
        this.$message.error(res.message);
      }
    },
    // 获取用户列表
    async getAllUserList () {
      const res = await userApi.getAllUserList();
      if (res.code === 200) {
        this.memberList = res.data
      } else {
        this.$message.error(res.message);
      }
    },
    // 节流
    throttle (fn, wait) {
      throttle(fn, wait);
    },
  }
}
</script>

<style lang="scss" scoped>
.rbca-container {
}
</style>